import { DateTime } from "luxon"

//PrimeReact
import { Accordion, AccordionTab } from "primereact/accordion"
import FormikTextInput from "../../../helpers/formikInputs/FormikTextInput"
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog"
import { Tooltip } from "primereact/tooltip"

//Housing components and assets
import myStyle from "../../../styles/housing/HousingManagementForm.module.css"
import Bed from "./Bed"
import { useField } from "formik"

export default function Room({
  index,
  values,
  disabled,
  onNewBedClick,
  refresh,
}) {
  const [, , removalHelper] = useField(`rooms[${index}].removalDate`)
  const [idField] = useField(`rooms[${index}].id`)

  const [nameField, nameMeta] = useField(`rooms[${index}].name`)
  let bedCounter = 0

  const beds = values.beds.filter(
    (bed) => bed.roomId === values.rooms[index].id && !bed.removalDate
  )
  const occupiedBeds = beds.filter((bed) => !!bed.isAllocated).length

  const confirmRemoval = () => {
    confirmDialog({
      message: (
        <>
          Do you want to remove this room? <br /> <br />
          Noe: All participant allocations to rooms will be removed as well.
        </>
      ),
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      accept: () => {
        removalHelper.setValue(DateTime.now().toUTC().toISO())
        refresh()
      },
    })
  }

  function RoomHeader() {
    return (
      <div className={myStyle.roomHeaderGridContainer}>
        <Tooltip target=".houseFormRoom_tt" />
        <div className={myStyle.roomHeaderGridTitle}>
          <label>{nameField.value}</label>
        </div>
        <div
          className={`houseFormRoom_tt ${myStyle.roomHeaderGridBeds}`}
          data-pr-tooltip="Beds available in this room"
        >
          <span className={`material-icons`}>{"bed"}</span>
          <label>{`: ${beds.length}`}</label>
        </div>
        <div
          className={`houseFormRoom_tt ${myStyle.roomHeaderGridOccupant}`}
          data-pr-tooltip="Participants allocated to beds"
        >
          <span className={`material-icons`}>{"person"}</span>
          <label>{`: ${occupiedBeds}`}</label>
        </div>
        <div className={myStyle.roomHeaderGridButtons}>
          <button
            type="button"
            className={`btn t-tip ${myStyle.roomHeaderButton}`}
            onClick={(e) => {
              e.stopPropagation()
              confirmRemoval()
            }}
            disabled={disabled}
          >
            <span className={`material-icons`}>{"delete"}</span>
          </button>
          <button
            type="button"
            className={`btn t-tip ${myStyle.roomHeaderButton}`}
            onClick={(e) => {
              e.stopPropagation()
              onNewBedClick()
              refresh()
            }}
            disabled={disabled}
          >
            <span className={`material-icons`}>{"add"}</span>
          </button>
        </div>
      </div>
    )
  }

  return (
    <Accordion
      style={{ marginBottom: "10px" }}
      activeIndex={values.rooms[index].isNew ? 0 : null}
    >
      <AccordionTab
        header={RoomHeader()}
        disabled={disabled}
        className={`${myStyle.roomBedContainer} ${
          !!nameMeta.error && !!nameMeta.touched
            ? myStyle.roomBedContainerError
            : ""
        }`}
      >
        <ConfirmDialog />
        <div className={myStyle.roomBedLabel}>
          <span className={`material-icons`}>{"house"}</span>
          <label>Room Name</label>
        </div>
        <FormikTextInput
          name={`rooms[${index}].name`}
          label=""
          disabled={disabled}
        />
        {values.beds.map((bed, index) => {
          if (bed.roomId === idField.value && !bed.removalDate) {
            bedCounter = bedCounter + 1
            return (
              <Bed
                index={index}
                disabled={disabled}
                roomBedCounter={bedCounter}
                key={index}
                refresh={refresh}
              />
            )
          } else {
            return null
          }
        })}
        <button
          className={`btn ${myStyle.roomNewBedButton}`}
          type="button"
          onClick={() => {
            onNewBedClick()
            refresh()
          }}
        >
          <span className={`material-icons`}>{"add"}</span> Add Bed
        </button>
      </AccordionTab>
    </Accordion>
  )
}
